import React from 'react';
import {ResultSubject} from '../../../../styled';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';


const Title = ({ item }: any) => {
  let secondTitle = (
    <span style={{fontWeight: 400}}>
          {item.type === 'folder' ? 'Folder: ' : 'File: '}
      <a
        href={item.url || `https://dropbox.com/home/${item.linkPath}`}
        target="dropbox"
        style={{color: '#0039BB', fontWeight: 600}}
        onClick={(e) => e.stopPropagation()}
      >
            {item.itemPath}
          </a>
        </span>
  )
  return (
    <ResultSubject>
      <HighlightMarker>
        {item.title} | {secondTitle}
      </HighlightMarker>
    </ResultSubject>
  )
}

export default Title;